import { useTranslation } from "react-i18next";

import { MFA_METHOD_ORDER, type MfaMethod } from "simplydo/core/mfa";

import { MfaMethodCard } from "./MfaMethodCard";

type MfaMethodPickerProps = {
  methods: MfaMethod[];
  pendingMethod?: MfaMethod | null;
  onSelect: (method: MfaMethod) => void;
};

export const MfaMethodPicker = ({
  methods,
  pendingMethod = null,
  onSelect,
}: MfaMethodPickerProps) => {
  const { t } = useTranslation();
  const sortedMethods = MFA_METHOD_ORDER.filter((method) =>
    methods.includes(method),
  );

  return (
    <>
      <p style={{ marginTop: 0, marginBottom: 16 }}>
        {t("entry.mfa.chooseMethodInfo")}
      </p>
      <div>
        {sortedMethods.map((method) => (
          <MfaMethodCard
            key={method}
            method={method}
            loading={pendingMethod === method}
            disabled={Boolean(pendingMethod) && pendingMethod !== method}
            onSelect={() => onSelect(method)}
          />
        ))}
      </div>
    </>
  );
};
